import React from 'react'
import { useSelector } from 'react-redux'
import styled, { } from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  iframe { border: none; }
`

export default function Chat (props) {
  const { fullScreen = false } = props
  const user = useSelector((state) => state.user)

  return (
    <Wrapper fullScreen={fullScreen}>
      <iframe
        data-user={user?.id}
        data-brand={user?.nowBrand}
        src={`${process.env.REACT_APP_CHAT_WEB_URL}?userId=${user?.id}&brandId=${user?.nowBrand}&groupId=${user?.nowGroup}`}
        title="Chat Web"
        width="100%"
        height="100%"
      />
    </Wrapper>
  )
}
